import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ApplicationAttachment } from '../../models/altinn-application/application-attachment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BackendApplicationService } from '../../services/backend/backend-application.service';
import { catchError, EMPTY, filter, map, Observable, switchMap, tap } from 'rxjs';
import { LandingPageStateService } from '../../services/landing-page-state.service';

@Component({
  selector: 'pdf-view-modal',
  templateUrl: './pdf-view-modal.component.html',
  styleUrl: './pdf-view-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PdfViewModalComponent implements OnInit, OnDestroy {
  attachment?: ApplicationAttachment;
  pdfSrc$!: Observable<string>;
  private objectUrl?: string;

  constructor(
    public bsModalRef: BsModalRef,
    readonly backendService: BackendApplicationService,
    readonly stateService: LandingPageStateService,
  ) {}

  ngOnInit(): void {
    if (!this.attachment) {
      this.pdfSrc$ = EMPTY;
      return;
    }
    const blobRef = this.attachment.blobReferenceId;
    this.pdfSrc$ = this.stateService.application$.pipe(
      map(application => application.applicationID),
      switchMap(applicationID => this.backendService.fetchAttachment(applicationID, blobRef)),
      filter((blob): blob is Blob => blob != null),
      tap(blob => {
        if (this.objectUrl) {
          URL.revokeObjectURL(this.objectUrl);
        }
        this.objectUrl = URL.createObjectURL(blob);
      }),
      map(() => this.objectUrl!),
      catchError(err => {
        console.error('Failed to load PDF attachment', err);
        return EMPTY;
      }),
    );
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = undefined;
    }
  }
}
